export default function updateAction(state, payload) {
  return {
    ...state,
    nadzorUpis: {
      ...state.nadzorUpis,
      ...payload,
    },
  };
}
